import { Injectable } from "@angular/core";
import { XsHttpApiService } from "../../common/services/xs-http-api.service";
import { XsAppConfigService } from "../../common/services/xs-app-config.service";
import { PlusdCommonService } from "./plusd-common.service";

@Injectable({
  providedIn: "root"
})

export class SsoService {
  constructor(
    public xsHttpApiService: XsHttpApiService,
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService,
  ) { }

  autenticar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/login/autenticar",
      parametro
    );
  }

  getconfirm(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/login/getConfirm",
      parametro
    );
  }

  getlogut(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/login/getLogut",
      parametro
    );
  }

  confirm(url,parametro): any {
    return this.xsHttpApiService.post(
      url,
      "/confirmsso2",parametro
    );
  }

  intento(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/login/intento",
      parametro
    );
  }

  validarCorreo(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/login/validarCorreo",
      parametro
    );
  }
  enviarCorreo(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/login/enviarCorreo",
      parametro
    );
  }

  restaurar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/login/restaurar",
      parametro
    );
  }

  recuperarGui(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/login/recuperarGui",
      parametro
    );
  }
}
